import gql from 'graphql-tag';

export default gql`
  mutation EstimateBurnedKcals($input: DailyTrackerEstimateBurnedKcalsInputType!) {
    dailyTracker {
      estimateBurnedKcals(input: $input) {
        ... on EstimatedActivity {
          activityName
          totalKcals
          durationMinutes
          imageUrl
          intensity
          activityType
          confidence
          distanceValue
          distanceUnit
          calculationMethod
          requestId
        }
        ... on AiAccessDenied {
          accessDeniedMessage: message
          accessDeniedDescription: description
        }
        ... on RateLimitExceeded {
          rateLimitExceededMessage: message
          rateLimitExceededDescription: description
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
